import React from "react";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  justify-self: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Title = styled.div`
  font-family: "Press Start 2P", monospace;
  font-size: 10px;
  margin-bottom: 6px;
`;

const Text = styled.div`
  font-family: "VT323", monospace;
  font-size: 16px;
`;

const OriginEntry = ({ title, subtitle, content }) => {
  return (
    <Wrapper>
      {title && <Title>{title}</Title>}
      {subtitle && <Text>{subtitle}</Text>}
      {content && <Text>{content}</Text>}
    </Wrapper>
  );
};

export default OriginEntry;
